import { Button, defaultIconSize, LabeledDiv, SingleSelect } from '@synqo/frontend-component-library';
import { IconScale } from '@tabler/icons-react';
import { EnumUnit } from '@Model';
import { useScaleSelection } from './useScaleSelection';

interface IWeighingButtonProps {
    doWeighing: () => void;
    allowedUnit?: EnumUnit;
}

export function WeighingButton({ allowedUnit, doWeighing }: IWeighingButtonProps) {
    const { selectedScale, setSelectedScale, scalesOptions, canUseAutomaticWeighing } = useScaleSelection(allowedUnit);

    const hasScales = scalesOptions.length > 0;

    let toolTip = '';
    if (!hasScales) {
        toolTip = 'Keine Waagen vorhanden';
    } else if (selectedScale === undefined) {
        toolTip = 'Es muss eine Waage ausgewählt sein';
    } else if (selectedScale.is_manual) {
        toolTip = 'Diese Waage kann nur händische Gewichte erfassen';
    }

    return (
        <LabeledDiv
            label={
                hasScales ? (
                    <SingleSelect
                        name="select_scale"
                        items={scalesOptions}
                        value={selectedScale?.id ?? ''}
                        onChange={setSelectedScale}
                        extraSmall
                        forceValue
                    />
                ) : (
                    <>&nbsp;</>
                )
            }
            htmlFor={''}
            forceRenderLabel
        >
            <Button
                fullWidth
                onClick={doWeighing}
                appearance={'outlined'}
                locked={!canUseAutomaticWeighing || !hasScales}
                tooltip={toolTip}
            >
                <IconScale size={defaultIconSize} />
                &nbsp;Wiegen
            </Button>
        </LabeledDiv>
    );
}
